'use strict';

var _ = require('lodash');
var StrategyMqSposSeason = function StrategyMqSposSeason(strategyHelper) {
  function getLabel(season) {
    return _.capitalize(season);
  }
  function getProfileLevel() {
    return 'MQ_SPOS_S';
  }
  function condition(quickFilterData, season) {
    return _.isArray(quickFilterData.seasons) && quickFilterData.seasons.indexOf(season) !== -1;
  }
  function profileMatched(quickFilterData, season, dowGroup) {
    return condition(quickFilterData, season, dowGroup);
  }
  function getFillData(quickFilterData, season, dowGroup) {
    return strategyHelper.getFillData(quickFilterData, season, dowGroup, condition);
  }
  return {
    getLabel: getLabel,
    getFillData: getFillData,
    profileMatched: profileMatched,
    getProfileLevel: getProfileLevel
  };
};
StrategyMqSposSeason.$inject = ['StrategyHelper'];
module.exports = StrategyMqSposSeason;